import * as React from 'react';
import type { Control, FieldValues, Validate } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';

import { Error } from 'ui';
import { errorMessages } from 'util/forms.util';

interface ValidationRule<T> {
  message: string;
  value: T;
}

interface Props {
  name: string;
  label: string;
  control?: Control;
  rules?: {
    required?: ValidationRule<boolean>;
    maxLength?: ValidationRule<number>;
    minLength?: ValidationRule<number>;
    max?: ValidationRule<number>;
    min?: ValidationRule<number>;
    pattern?: ValidationRule<RegExp>;
    validate?:
      | Validate<string | number, FieldValues>
      | Record<string, Validate<string | number, FieldValues>>;
  };
  dataCy?: string;
}

/**
 * Return a hidden input component.
 *
 * @param props name and label (optional: control, rules, dataCy).
 * @returns a hidden input component.
 */
export const InputHidden: React.FC<Props> = (props) => {
  return (
    <FormControl data-cy={props.dataCy}>
      <Controller
        control={props.control}
        name={props.name}
        rules={props.rules}
        render={({ field: {}, fieldState: { error } }) => (
          <>
            <input type="hidden" name={props.name} />
            <Error
              content={error ? `* ${props.label} ${error.message || errorMessages()[error.type]}` : ''}
              dataCy="validation-message"
            />
          </>
        )}
      />
    </FormControl>
  );
};
